import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
const commonStyles = css`
  ${MQ.MobileXs} {
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)};
  }
`;
export const textWrapper = css`
  display: flex;
  align-items: center;
  gap: 4px;
  &:not(first-of-type) {
    margin-top: 8px;
  }
  ${MQ.MobileXs} {
    display: block;
    width: 100%;
  }
  ${MQ.MediaMd} {
    display: flex;
    flex-basis: 50%;
  }
  ${MQ.MediaLg} {
    display: flex;
    flex-basis: 40%;
  }
`;

export const crewWrapper = (spaceY: string) => css`
  margin-top: ${spaceY}px;
  display: flex;
  flex-wrap: wrap;
`;

export const prefixText = (hasLink: boolean, textColor = colors.white) => css`
  ${commonStyles}
  ${hasLink
    ? `
    cursor:pointer;
    color:${colors.Lavender};
  `
    : `color:${textColor}`}
`;
export const suffixText = css`
  ${commonStyles}
  color: ${colors.greyText};
`;
